import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CardToken } from './models/card-token.model';

export interface CardTokenState extends EntityState<CardToken> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'card-token', idKey: 'TokenId', cache: { ttl: 20000 } })
export class CardTokenStore extends EntityStore<CardTokenState> {
  constructor() {
    super();
  }
}
